var map = {
	"./C2c.svg": 37937,
	"./accountAllAssets.svg": 83172,
	"./add.svg": 38929,
	"./addButtom.svg": 24309,
	"./airdropPlan.svg": 74484,
	"./arrow-line.svg": 45325,
	"./arrow.svg": 1164,
	"./arrow2.svg": 85652,
	"./arrowDown.svg": 6765,
	"./arrowRight.svg": 73226,
	"./arrowUp.svg": 38087,
	"./assets.svg": 14050,
	"./auth.svg": 6173,
	"./authentication.svg": 87864,
	"./backTop.svg": 32860,
	"./backward.svg": 70521,
	"./bindMail.svg": 1297,
	"./book.svg": 75036,
	"./buyCoinHistory.svg": 92924,
	"./c2cOrder.svg": 84035,
	"./checked.svg": 59913,
	"./close.svg": 13177,
	"./codeCopy.svg": 20659,
	"./coin.svg": 24153,
	"./coinSearch.svg": 36121,
	"./comment.svg": 20771,
	"./community.svg": 51464,
	"./completed.svg": 47449,
	"./contactService.svg": 61057,
	"./copy.svg": 5229,
	"./decline_rank.svg": 67072,
	"./delete.svg": 41841,
	"./depositWithdrawal.svg": 44209,
	"./deposit_withdrawal.svg": 53869,
	"./discover.svg": 16769,
	"./download.svg": 74537,
	"./downloadCloud.svg": 78275,
	"./download_mobile.svg": 2982,
	"./dragTable.svg": 65774,
	"./edit.svg": 32311,
	"./editBoxLine.svg": 68575,
	"./exit.svg": 41899,
	"./fav.svg": 45035,
	"./filter.svg": 11449,
	"./financeAccount.svg": 20073,
	"./findIcon.svg": 63170,
	"./flags/ad.svg": 64387,
	"./flags/ae.svg": 79659,
	"./flags/af.svg": 9060,
	"./flags/ag.svg": 58267,
	"./flags/ai.svg": 49171,
	"./flags/al.svg": 82987,
	"./flags/am.svg": 56187,
	"./flags/ao.svg": 19680,
	"./flags/ar.svg": 77147,
	"./flags/at.svg": 95627,
	"./flags/au.svg": 80136,
	"./flags/az.svg": 46360,
	"./flags/ba.svg": 11030,
	"./flags/bb.svg": 77124,
	"./flags/bd.svg": 13678,
	"./flags/be.svg": 40522,
	"./flags/bf.svg": 36275,
	"./flags/bg.svg": 19140,
	"./flags/bh.svg": 17214,
	"./flags/bi.svg": 66998,
	"./flags/bj.svg": 6135,
	"./flags/bm.svg": 73000,
	"./flags/bn.svg": 16735,
	"./flags/bo.svg": 90716,
	"./flags/br.svg": 64299,
	"./flags/bs.svg": 93868,
	"./flags/bt.svg": 44397,
	"./flags/bw.svg": 34148,
	"./flags/by.svg": 86535,
	"./flags/bz.svg": 82630,
	"./flags/ca.svg": 87688,
	"./flags/cd.svg": 95010,
	"./flags/cf.svg": 70867,
	"./flags/cg.svg": 23358,
	"./flags/ch.svg": 31261,
	"./flags/ci.svg": 22191,
	"./flags/ck.svg": 69446,
	"./flags/cl.svg": 21373,
	"./flags/cm.svg": 54520,
	"./flags/cn.svg": 52042,
	"./flags/co.svg": 53009,
	"./flags/cr.svg": 22121,
	"./flags/cu.svg": 5762,
	"./flags/cv.svg": 15861,
	"./flags/cw.svg": 29407,
	"./flags/cy.svg": 61358,
	"./flags/cz.svg": 17213,
	"./flags/de.svg": 64314,
	"./flags/dj.svg": 76945,
	"./flags/dk.svg": 94125,
	"./flags/dm.svg": 49575,
	"./flags/do.svg": 99664,
	"./flags/dz.svg": 4601,
	"./flags/ec.svg": 17089,
	"./flags/ee.svg": 71699,
	"./flags/eg.svg": 31174,
	"./flags/er.svg": 90261,
	"./flags/es.svg": 20491,
	"./flags/et.svg": 49465,
	"./flags/fi.svg": 28919,
	"./flags/fj.svg": 54479,
	"./flags/fm.svg": 99858,
	"./flags/fr.svg": 24694,
	"./flags/ga.svg": 86695,
	"./flags/gb.svg": 88483,
	"./flags/gd.svg": 23698,
	"./flags/ge.svg": 62532,
	"./flags/gh.svg": 92091,
	"./flags/gi.svg": 32563,
	"./flags/gm.svg": 80781,
	"./flags/gn.svg": 66581,
	"./flags/gq.svg": 72093,
	"./flags/gr.svg": 4544,
	"./flags/gt.svg": 71797,
	"./flags/gw.svg": 48175,
	"./flags/gy.svg": 44712,
	"./flags/hk.svg": 70873,
	"./flags/hn.svg": 72254,
	"./flags/hr.svg": 66320,
	"./flags/ht.svg": 59620,
	"./flags/hu.svg": 71619,
	"./flags/id.svg": 40214,
	"./flags/ie.svg": 26083,
	"./flags/il.svg": 7965,
	"./flags/in.svg": 26613,
	"./flags/iq.svg": 37729,
	"./flags/ir.svg": 24622,
	"./flags/is.svg": 43079,
	"./flags/it.svg": 31933,
	"./flags/jm.svg": 74693,
	"./flags/jo.svg": 90037,
	"./flags/jp.svg": 53119,
	"./flags/ke.svg": 76644,
	"./flags/kg.svg": 47253,
	"./flags/kh.svg": 91970,
	"./flags/ki.svg": 21013,
	"./flags/km.svg": 20655,
	"./flags/kn.svg": 11123,
	"./flags/kp.svg": 9287,
	"./flags/kr.svg": 89991,
	"./flags/kw.svg": 71594,
	"./flags/ky.svg": 40320,
	"./flags/kz.svg": 56682,
	"./flags/la.svg": 94386,
	"./flags/lb.svg": 94937,
	"./flags/lc.svg": 87025,
	"./flags/li.svg": 9821,
	"./flags/lk.svg": 27525,
	"./flags/lr.svg": 20129,
	"./flags/ls.svg": 80449,
	"./flags/lt.svg": 46504,
	"./flags/lu.svg": 48141,
	"./flags/lv.svg": 30490,
	"./flags/ly.svg": 72990,
	"./flags/ma.svg": 97094,
	"./flags/mc.svg": 29935,
	"./flags/md.svg": 45389,
	"./flags/me.svg": 98901,
	"./flags/mg.svg": 82406,
	"./flags/mh.svg": 98635,
	"./flags/mk.svg": 88402,
	"./flags/ml.svg": 11221,
	"./flags/mm.svg": 99670,
	"./flags/mn.svg": 26031,
	"./flags/mo.svg": 43357,
	"./flags/mr.svg": 76087,
	"./flags/mt.svg": 81134,
	"./flags/mu.svg": 85355,
	"./flags/mv.svg": 55671,
	"./flags/mw.svg": 13109,
	"./flags/mx.svg": 74495,
	"./flags/my.svg": 59249,
	"./flags/mz.svg": 69127,
	"./flags/na.svg": 56790,
	"./flags/nc.svg": 82298,
	"./flags/ne.svg": 32640,
	"./flags/ng.svg": 90614,
	"./flags/ni.svg": 24235,
	"./flags/nl.svg": 26156,
	"./flags/no.svg": 96464,
	"./flags/np.svg": 26279,
	"./flags/nr.svg": 76333,
	"./flags/nz.svg": 90385,
	"./flags/om.svg": 34887,
	"./flags/pa.svg": 96939,
	"./flags/pe.svg": 65564,
	"./flags/pg.svg": 64135,
	"./flags/ph.svg": 83972,
	"./flags/pk.svg": 10906,
	"./flags/pl.svg": 4349,
	"./flags/ps.svg": 7918,
	"./flags/pt.svg": 21592,
	"./flags/pw.svg": 79272,
	"./flags/py.svg": 67461,
	"./flags/qa.svg": 72781,
	"./flags/re.svg": 85926,
	"./flags/ro.svg": 85401,
	"./flags/rs.svg": 85096,
	"./flags/ru.svg": 53665,
	"./flags/rw.svg": 53372,
	"./flags/sa.svg": 75593,
	"./flags/sb.svg": 43662,
	"./flags/sc.svg": 44075,
	"./flags/sd.svg": 84591,
	"./flags/se.svg": 34063,
	"./flags/sg.svg": 54462,
	"./flags/si.svg": 76160,
	"./flags/sk.svg": 16508,
	"./flags/sl.svg": 8704,
	"./flags/sm.svg": 79418,
	"./flags/sn.svg": 80473,
	"./flags/so.svg": 39638,
	"./flags/sr.svg": 36525,
	"./flags/ss.svg": 67332,
	"./flags/st.svg": 19433,
	"./flags/sv.svg": 82022,
	"./flags/sy.svg": 80504,
	"./flags/sz.svg": 82207,
	"./flags/td.svg": 37734,
	"./flags/tg.svg": 45003,
	"./flags/th.svg": 5277,
	"./flags/tj.svg": 7467,
	"./flags/tl.svg": 67194,
	"./flags/tm.svg": 52029,
	"./flags/tn.svg": 6882,
	"./flags/to.svg": 6800,
	"./flags/tr.svg": 41818,
	"./flags/tt.svg": 28400,
	"./flags/tv.svg": 99575,
	"./flags/tw.svg": 62284,
	"./flags/tz.svg": 84755,
	"./flags/ua.svg": 151,
	"./flags/ug.svg": 90906,
	"./flags/us.svg": 1216,
	"./flags/uy.svg": 28452,
	"./flags/uz.svg": 52365,
	"./flags/va.svg": 27021,
	"./flags/vc.svg": 20512,
	"./flags/ve.svg": 8917,
	"./flags/vg.svg": 28522,
	"./flags/vi.svg": 72789,
	"./flags/vn.svg": 945,
	"./flags/vu.svg": 32851,
	"./flags/ws.svg": 55076,
	"./flags/xk.svg": 97835,
	"./flags/ye.svg": 53456,
	"./flags/za.svg": 65900,
	"./flags/zm.svg": 95903,
	"./flags/zw.svg": 32522,
	"./flexRegular.svg": 23787,
	"./forward.svg": 1511,
	"./freeGit.svg": 23539,
	"./giftBag.svg": 24996,
	"./globalLine.svg": 94244,
	"./google.svg": 3901,
	"./guide.svg": 94751,
	"./history.svg": 37120,
	"./historyRecords.svg": 6490,
	"./idAuth.svg": 88806,
	"./image.svg": 64670,
	"./inputClose.svg": 99911,
	"./inputCloseDark.svg": 72204,
	"./invite_friends.svg": 66438,
	"./invitefriends.svg": 66787,
	"./joinKiki.svg": 29221,
	"./kikiMsg.svg": 21218,
	"./kycFailed.svg": 84371,
	"./kycHaveInfo.svg": 11269,
	"./kycIcon.svg": 48780,
	"./kycInReview.svg": 35134,
	"./kycNoInfo.svg": 46078,
	"./kycRejected.svg": 46841,
	"./kycSuccess.svg": 33272,
	"./kycUnauthorized.svg": 90693,
	"./kycUnverified.svg": 99386,
	"./kycVerified.svg": 82922,
	"./kycVerifying.svg": 19473,
	"./kycWarnning.svg": 36791,
	"./left.svg": 84192,
	"./like.svg": 37990,
	"./lineArrow.svg": 36503,
	"./link.svg": 56677,
	"./lock.svg": 92447,
	"./logo-dark.svg": 88338,
	"./logo.svg": 42787,
	"./love.svg": 6825,
	"./mail.svg": 9610,
	"./market.svg": 92448,
	"./marketStation.svg": 13754,
	"./merchantcenter.svg": 55093,
	"./message.svg": 21348,
	"./modalClose.svg": 39224,
	"./modalNone.svg": 55590,
	"./mytransaction.svg": 12465,
	"./navabar_logo.svg": 47936,
	"./new.svg": 21234,
	"./newCoin.svg": 48696,
	"./newCoin_rank.svg": 48125,
	"./nextIcon.svg": 15999,
	"./notSeeIcon.svg": 45800,
	"./othersettings.svg": 71943,
	"./payment.svg": 84005,
	"./phone.svg": 53082,
	"./plusSign.svg": 97097,
	"./preIcon.svg": 53996,
	"./question.svg": 60340,
	"./recommend_rank.svg": 5726,
	"./refreshLine.svg": 45580,
	"./regularInvestment.svg": 33787,
	"./review.svg": 61267,
	"./riseFall.svg": 79333,
	"./rise_rank.svg": 89974,
	"./risk.svg": 55374,
	"./riskTip.svg": 5209,
	"./search.svg": 1917,
	"./securitycenter.svg": 60910,
	"./seeIcon.svg": 77666,
	"./select.svg": 57694,
	"./share.svg": 87575,
	"./spotOrder.svg": 41706,
	"./star.svg": 15718,
	"./tableCopy.svg": 84829,
	"./theCircle.svg": 33328,
	"./theFire.svg": 60238,
	"./timeSvg.svg": 94415,
	"./toTheRight.svg": 55349,
	"./topic.svg": 19416,
	"./topping.svg": 37032,
	"./trade.svg": 37325,
	"./trade_rank.svg": 30148,
	"./transferAccount.svg": 51406,
	"./uploadDelete.svg": 81228,
	"./uploadPlus.svg": 97430,
	"./video.svg": 86731,
	"./web3Wallet.svg": 88797,
	"./yieldOrder.svg": 14549,
	"src/images/svgIcon/C2c.svg": 37937,
	"src/images/svgIcon/accountAllAssets.svg": 83172,
	"src/images/svgIcon/add.svg": 38929,
	"src/images/svgIcon/addButtom.svg": 24309,
	"src/images/svgIcon/airdropPlan.svg": 74484,
	"src/images/svgIcon/arrow-line.svg": 45325,
	"src/images/svgIcon/arrow.svg": 1164,
	"src/images/svgIcon/arrow2.svg": 85652,
	"src/images/svgIcon/arrowDown.svg": 6765,
	"src/images/svgIcon/arrowRight.svg": 73226,
	"src/images/svgIcon/arrowUp.svg": 38087,
	"src/images/svgIcon/assets.svg": 14050,
	"src/images/svgIcon/auth.svg": 6173,
	"src/images/svgIcon/authentication.svg": 87864,
	"src/images/svgIcon/backTop.svg": 32860,
	"src/images/svgIcon/backward.svg": 70521,
	"src/images/svgIcon/bindMail.svg": 1297,
	"src/images/svgIcon/book.svg": 75036,
	"src/images/svgIcon/buyCoinHistory.svg": 92924,
	"src/images/svgIcon/c2cOrder.svg": 84035,
	"src/images/svgIcon/checked.svg": 59913,
	"src/images/svgIcon/close.svg": 13177,
	"src/images/svgIcon/codeCopy.svg": 20659,
	"src/images/svgIcon/coin.svg": 24153,
	"src/images/svgIcon/coinSearch.svg": 36121,
	"src/images/svgIcon/comment.svg": 20771,
	"src/images/svgIcon/community.svg": 51464,
	"src/images/svgIcon/completed.svg": 47449,
	"src/images/svgIcon/contactService.svg": 61057,
	"src/images/svgIcon/copy.svg": 5229,
	"src/images/svgIcon/decline_rank.svg": 67072,
	"src/images/svgIcon/delete.svg": 41841,
	"src/images/svgIcon/depositWithdrawal.svg": 44209,
	"src/images/svgIcon/deposit_withdrawal.svg": 53869,
	"src/images/svgIcon/discover.svg": 16769,
	"src/images/svgIcon/download.svg": 74537,
	"src/images/svgIcon/downloadCloud.svg": 78275,
	"src/images/svgIcon/download_mobile.svg": 2982,
	"src/images/svgIcon/dragTable.svg": 65774,
	"src/images/svgIcon/edit.svg": 32311,
	"src/images/svgIcon/editBoxLine.svg": 68575,
	"src/images/svgIcon/exit.svg": 41899,
	"src/images/svgIcon/fav.svg": 45035,
	"src/images/svgIcon/filter.svg": 11449,
	"src/images/svgIcon/financeAccount.svg": 20073,
	"src/images/svgIcon/findIcon.svg": 63170,
	"src/images/svgIcon/flags/ad.svg": 64387,
	"src/images/svgIcon/flags/ae.svg": 79659,
	"src/images/svgIcon/flags/af.svg": 9060,
	"src/images/svgIcon/flags/ag.svg": 58267,
	"src/images/svgIcon/flags/ai.svg": 49171,
	"src/images/svgIcon/flags/al.svg": 82987,
	"src/images/svgIcon/flags/am.svg": 56187,
	"src/images/svgIcon/flags/ao.svg": 19680,
	"src/images/svgIcon/flags/ar.svg": 77147,
	"src/images/svgIcon/flags/at.svg": 95627,
	"src/images/svgIcon/flags/au.svg": 80136,
	"src/images/svgIcon/flags/az.svg": 46360,
	"src/images/svgIcon/flags/ba.svg": 11030,
	"src/images/svgIcon/flags/bb.svg": 77124,
	"src/images/svgIcon/flags/bd.svg": 13678,
	"src/images/svgIcon/flags/be.svg": 40522,
	"src/images/svgIcon/flags/bf.svg": 36275,
	"src/images/svgIcon/flags/bg.svg": 19140,
	"src/images/svgIcon/flags/bh.svg": 17214,
	"src/images/svgIcon/flags/bi.svg": 66998,
	"src/images/svgIcon/flags/bj.svg": 6135,
	"src/images/svgIcon/flags/bm.svg": 73000,
	"src/images/svgIcon/flags/bn.svg": 16735,
	"src/images/svgIcon/flags/bo.svg": 90716,
	"src/images/svgIcon/flags/br.svg": 64299,
	"src/images/svgIcon/flags/bs.svg": 93868,
	"src/images/svgIcon/flags/bt.svg": 44397,
	"src/images/svgIcon/flags/bw.svg": 34148,
	"src/images/svgIcon/flags/by.svg": 86535,
	"src/images/svgIcon/flags/bz.svg": 82630,
	"src/images/svgIcon/flags/ca.svg": 87688,
	"src/images/svgIcon/flags/cd.svg": 95010,
	"src/images/svgIcon/flags/cf.svg": 70867,
	"src/images/svgIcon/flags/cg.svg": 23358,
	"src/images/svgIcon/flags/ch.svg": 31261,
	"src/images/svgIcon/flags/ci.svg": 22191,
	"src/images/svgIcon/flags/ck.svg": 69446,
	"src/images/svgIcon/flags/cl.svg": 21373,
	"src/images/svgIcon/flags/cm.svg": 54520,
	"src/images/svgIcon/flags/cn.svg": 52042,
	"src/images/svgIcon/flags/co.svg": 53009,
	"src/images/svgIcon/flags/cr.svg": 22121,
	"src/images/svgIcon/flags/cu.svg": 5762,
	"src/images/svgIcon/flags/cv.svg": 15861,
	"src/images/svgIcon/flags/cw.svg": 29407,
	"src/images/svgIcon/flags/cy.svg": 61358,
	"src/images/svgIcon/flags/cz.svg": 17213,
	"src/images/svgIcon/flags/de.svg": 64314,
	"src/images/svgIcon/flags/dj.svg": 76945,
	"src/images/svgIcon/flags/dk.svg": 94125,
	"src/images/svgIcon/flags/dm.svg": 49575,
	"src/images/svgIcon/flags/do.svg": 99664,
	"src/images/svgIcon/flags/dz.svg": 4601,
	"src/images/svgIcon/flags/ec.svg": 17089,
	"src/images/svgIcon/flags/ee.svg": 71699,
	"src/images/svgIcon/flags/eg.svg": 31174,
	"src/images/svgIcon/flags/er.svg": 90261,
	"src/images/svgIcon/flags/es.svg": 20491,
	"src/images/svgIcon/flags/et.svg": 49465,
	"src/images/svgIcon/flags/fi.svg": 28919,
	"src/images/svgIcon/flags/fj.svg": 54479,
	"src/images/svgIcon/flags/fm.svg": 99858,
	"src/images/svgIcon/flags/fr.svg": 24694,
	"src/images/svgIcon/flags/ga.svg": 86695,
	"src/images/svgIcon/flags/gb.svg": 88483,
	"src/images/svgIcon/flags/gd.svg": 23698,
	"src/images/svgIcon/flags/ge.svg": 62532,
	"src/images/svgIcon/flags/gh.svg": 92091,
	"src/images/svgIcon/flags/gi.svg": 32563,
	"src/images/svgIcon/flags/gm.svg": 80781,
	"src/images/svgIcon/flags/gn.svg": 66581,
	"src/images/svgIcon/flags/gq.svg": 72093,
	"src/images/svgIcon/flags/gr.svg": 4544,
	"src/images/svgIcon/flags/gt.svg": 71797,
	"src/images/svgIcon/flags/gw.svg": 48175,
	"src/images/svgIcon/flags/gy.svg": 44712,
	"src/images/svgIcon/flags/hk.svg": 70873,
	"src/images/svgIcon/flags/hn.svg": 72254,
	"src/images/svgIcon/flags/hr.svg": 66320,
	"src/images/svgIcon/flags/ht.svg": 59620,
	"src/images/svgIcon/flags/hu.svg": 71619,
	"src/images/svgIcon/flags/id.svg": 40214,
	"src/images/svgIcon/flags/ie.svg": 26083,
	"src/images/svgIcon/flags/il.svg": 7965,
	"src/images/svgIcon/flags/in.svg": 26613,
	"src/images/svgIcon/flags/iq.svg": 37729,
	"src/images/svgIcon/flags/ir.svg": 24622,
	"src/images/svgIcon/flags/is.svg": 43079,
	"src/images/svgIcon/flags/it.svg": 31933,
	"src/images/svgIcon/flags/jm.svg": 74693,
	"src/images/svgIcon/flags/jo.svg": 90037,
	"src/images/svgIcon/flags/jp.svg": 53119,
	"src/images/svgIcon/flags/ke.svg": 76644,
	"src/images/svgIcon/flags/kg.svg": 47253,
	"src/images/svgIcon/flags/kh.svg": 91970,
	"src/images/svgIcon/flags/ki.svg": 21013,
	"src/images/svgIcon/flags/km.svg": 20655,
	"src/images/svgIcon/flags/kn.svg": 11123,
	"src/images/svgIcon/flags/kp.svg": 9287,
	"src/images/svgIcon/flags/kr.svg": 89991,
	"src/images/svgIcon/flags/kw.svg": 71594,
	"src/images/svgIcon/flags/ky.svg": 40320,
	"src/images/svgIcon/flags/kz.svg": 56682,
	"src/images/svgIcon/flags/la.svg": 94386,
	"src/images/svgIcon/flags/lb.svg": 94937,
	"src/images/svgIcon/flags/lc.svg": 87025,
	"src/images/svgIcon/flags/li.svg": 9821,
	"src/images/svgIcon/flags/lk.svg": 27525,
	"src/images/svgIcon/flags/lr.svg": 20129,
	"src/images/svgIcon/flags/ls.svg": 80449,
	"src/images/svgIcon/flags/lt.svg": 46504,
	"src/images/svgIcon/flags/lu.svg": 48141,
	"src/images/svgIcon/flags/lv.svg": 30490,
	"src/images/svgIcon/flags/ly.svg": 72990,
	"src/images/svgIcon/flags/ma.svg": 97094,
	"src/images/svgIcon/flags/mc.svg": 29935,
	"src/images/svgIcon/flags/md.svg": 45389,
	"src/images/svgIcon/flags/me.svg": 98901,
	"src/images/svgIcon/flags/mg.svg": 82406,
	"src/images/svgIcon/flags/mh.svg": 98635,
	"src/images/svgIcon/flags/mk.svg": 88402,
	"src/images/svgIcon/flags/ml.svg": 11221,
	"src/images/svgIcon/flags/mm.svg": 99670,
	"src/images/svgIcon/flags/mn.svg": 26031,
	"src/images/svgIcon/flags/mo.svg": 43357,
	"src/images/svgIcon/flags/mr.svg": 76087,
	"src/images/svgIcon/flags/mt.svg": 81134,
	"src/images/svgIcon/flags/mu.svg": 85355,
	"src/images/svgIcon/flags/mv.svg": 55671,
	"src/images/svgIcon/flags/mw.svg": 13109,
	"src/images/svgIcon/flags/mx.svg": 74495,
	"src/images/svgIcon/flags/my.svg": 59249,
	"src/images/svgIcon/flags/mz.svg": 69127,
	"src/images/svgIcon/flags/na.svg": 56790,
	"src/images/svgIcon/flags/nc.svg": 82298,
	"src/images/svgIcon/flags/ne.svg": 32640,
	"src/images/svgIcon/flags/ng.svg": 90614,
	"src/images/svgIcon/flags/ni.svg": 24235,
	"src/images/svgIcon/flags/nl.svg": 26156,
	"src/images/svgIcon/flags/no.svg": 96464,
	"src/images/svgIcon/flags/np.svg": 26279,
	"src/images/svgIcon/flags/nr.svg": 76333,
	"src/images/svgIcon/flags/nz.svg": 90385,
	"src/images/svgIcon/flags/om.svg": 34887,
	"src/images/svgIcon/flags/pa.svg": 96939,
	"src/images/svgIcon/flags/pe.svg": 65564,
	"src/images/svgIcon/flags/pg.svg": 64135,
	"src/images/svgIcon/flags/ph.svg": 83972,
	"src/images/svgIcon/flags/pk.svg": 10906,
	"src/images/svgIcon/flags/pl.svg": 4349,
	"src/images/svgIcon/flags/ps.svg": 7918,
	"src/images/svgIcon/flags/pt.svg": 21592,
	"src/images/svgIcon/flags/pw.svg": 79272,
	"src/images/svgIcon/flags/py.svg": 67461,
	"src/images/svgIcon/flags/qa.svg": 72781,
	"src/images/svgIcon/flags/re.svg": 85926,
	"src/images/svgIcon/flags/ro.svg": 85401,
	"src/images/svgIcon/flags/rs.svg": 85096,
	"src/images/svgIcon/flags/ru.svg": 53665,
	"src/images/svgIcon/flags/rw.svg": 53372,
	"src/images/svgIcon/flags/sa.svg": 75593,
	"src/images/svgIcon/flags/sb.svg": 43662,
	"src/images/svgIcon/flags/sc.svg": 44075,
	"src/images/svgIcon/flags/sd.svg": 84591,
	"src/images/svgIcon/flags/se.svg": 34063,
	"src/images/svgIcon/flags/sg.svg": 54462,
	"src/images/svgIcon/flags/si.svg": 76160,
	"src/images/svgIcon/flags/sk.svg": 16508,
	"src/images/svgIcon/flags/sl.svg": 8704,
	"src/images/svgIcon/flags/sm.svg": 79418,
	"src/images/svgIcon/flags/sn.svg": 80473,
	"src/images/svgIcon/flags/so.svg": 39638,
	"src/images/svgIcon/flags/sr.svg": 36525,
	"src/images/svgIcon/flags/ss.svg": 67332,
	"src/images/svgIcon/flags/st.svg": 19433,
	"src/images/svgIcon/flags/sv.svg": 82022,
	"src/images/svgIcon/flags/sy.svg": 80504,
	"src/images/svgIcon/flags/sz.svg": 82207,
	"src/images/svgIcon/flags/td.svg": 37734,
	"src/images/svgIcon/flags/tg.svg": 45003,
	"src/images/svgIcon/flags/th.svg": 5277,
	"src/images/svgIcon/flags/tj.svg": 7467,
	"src/images/svgIcon/flags/tl.svg": 67194,
	"src/images/svgIcon/flags/tm.svg": 52029,
	"src/images/svgIcon/flags/tn.svg": 6882,
	"src/images/svgIcon/flags/to.svg": 6800,
	"src/images/svgIcon/flags/tr.svg": 41818,
	"src/images/svgIcon/flags/tt.svg": 28400,
	"src/images/svgIcon/flags/tv.svg": 99575,
	"src/images/svgIcon/flags/tw.svg": 62284,
	"src/images/svgIcon/flags/tz.svg": 84755,
	"src/images/svgIcon/flags/ua.svg": 151,
	"src/images/svgIcon/flags/ug.svg": 90906,
	"src/images/svgIcon/flags/us.svg": 1216,
	"src/images/svgIcon/flags/uy.svg": 28452,
	"src/images/svgIcon/flags/uz.svg": 52365,
	"src/images/svgIcon/flags/va.svg": 27021,
	"src/images/svgIcon/flags/vc.svg": 20512,
	"src/images/svgIcon/flags/ve.svg": 8917,
	"src/images/svgIcon/flags/vg.svg": 28522,
	"src/images/svgIcon/flags/vi.svg": 72789,
	"src/images/svgIcon/flags/vn.svg": 945,
	"src/images/svgIcon/flags/vu.svg": 32851,
	"src/images/svgIcon/flags/ws.svg": 55076,
	"src/images/svgIcon/flags/xk.svg": 97835,
	"src/images/svgIcon/flags/ye.svg": 53456,
	"src/images/svgIcon/flags/za.svg": 65900,
	"src/images/svgIcon/flags/zm.svg": 95903,
	"src/images/svgIcon/flags/zw.svg": 32522,
	"src/images/svgIcon/flexRegular.svg": 23787,
	"src/images/svgIcon/forward.svg": 1511,
	"src/images/svgIcon/freeGit.svg": 23539,
	"src/images/svgIcon/giftBag.svg": 24996,
	"src/images/svgIcon/globalLine.svg": 94244,
	"src/images/svgIcon/google.svg": 3901,
	"src/images/svgIcon/guide.svg": 94751,
	"src/images/svgIcon/history.svg": 37120,
	"src/images/svgIcon/historyRecords.svg": 6490,
	"src/images/svgIcon/idAuth.svg": 88806,
	"src/images/svgIcon/image.svg": 64670,
	"src/images/svgIcon/inputClose.svg": 99911,
	"src/images/svgIcon/inputCloseDark.svg": 72204,
	"src/images/svgIcon/invite_friends.svg": 66438,
	"src/images/svgIcon/invitefriends.svg": 66787,
	"src/images/svgIcon/joinKiki.svg": 29221,
	"src/images/svgIcon/kikiMsg.svg": 21218,
	"src/images/svgIcon/kycFailed.svg": 84371,
	"src/images/svgIcon/kycHaveInfo.svg": 11269,
	"src/images/svgIcon/kycIcon.svg": 48780,
	"src/images/svgIcon/kycInReview.svg": 35134,
	"src/images/svgIcon/kycNoInfo.svg": 46078,
	"src/images/svgIcon/kycRejected.svg": 46841,
	"src/images/svgIcon/kycSuccess.svg": 33272,
	"src/images/svgIcon/kycUnauthorized.svg": 90693,
	"src/images/svgIcon/kycUnverified.svg": 99386,
	"src/images/svgIcon/kycVerified.svg": 82922,
	"src/images/svgIcon/kycVerifying.svg": 19473,
	"src/images/svgIcon/kycWarnning.svg": 36791,
	"src/images/svgIcon/left.svg": 84192,
	"src/images/svgIcon/like.svg": 37990,
	"src/images/svgIcon/lineArrow.svg": 36503,
	"src/images/svgIcon/link.svg": 56677,
	"src/images/svgIcon/lock.svg": 92447,
	"src/images/svgIcon/logo-dark.svg": 88338,
	"src/images/svgIcon/logo.svg": 42787,
	"src/images/svgIcon/love.svg": 6825,
	"src/images/svgIcon/mail.svg": 9610,
	"src/images/svgIcon/market.svg": 92448,
	"src/images/svgIcon/marketStation.svg": 13754,
	"src/images/svgIcon/merchantcenter.svg": 55093,
	"src/images/svgIcon/message.svg": 21348,
	"src/images/svgIcon/modalClose.svg": 39224,
	"src/images/svgIcon/modalNone.svg": 55590,
	"src/images/svgIcon/mytransaction.svg": 12465,
	"src/images/svgIcon/navabar_logo.svg": 47936,
	"src/images/svgIcon/new.svg": 21234,
	"src/images/svgIcon/newCoin.svg": 48696,
	"src/images/svgIcon/newCoin_rank.svg": 48125,
	"src/images/svgIcon/nextIcon.svg": 15999,
	"src/images/svgIcon/notSeeIcon.svg": 45800,
	"src/images/svgIcon/othersettings.svg": 71943,
	"src/images/svgIcon/payment.svg": 84005,
	"src/images/svgIcon/phone.svg": 53082,
	"src/images/svgIcon/plusSign.svg": 97097,
	"src/images/svgIcon/preIcon.svg": 53996,
	"src/images/svgIcon/question.svg": 60340,
	"src/images/svgIcon/recommend_rank.svg": 5726,
	"src/images/svgIcon/refreshLine.svg": 45580,
	"src/images/svgIcon/regularInvestment.svg": 33787,
	"src/images/svgIcon/review.svg": 61267,
	"src/images/svgIcon/riseFall.svg": 79333,
	"src/images/svgIcon/rise_rank.svg": 89974,
	"src/images/svgIcon/risk.svg": 55374,
	"src/images/svgIcon/riskTip.svg": 5209,
	"src/images/svgIcon/search.svg": 1917,
	"src/images/svgIcon/securitycenter.svg": 60910,
	"src/images/svgIcon/seeIcon.svg": 77666,
	"src/images/svgIcon/select.svg": 57694,
	"src/images/svgIcon/share.svg": 87575,
	"src/images/svgIcon/spotOrder.svg": 41706,
	"src/images/svgIcon/star.svg": 15718,
	"src/images/svgIcon/tableCopy.svg": 84829,
	"src/images/svgIcon/theCircle.svg": 33328,
	"src/images/svgIcon/theFire.svg": 60238,
	"src/images/svgIcon/timeSvg.svg": 94415,
	"src/images/svgIcon/toTheRight.svg": 55349,
	"src/images/svgIcon/topic.svg": 19416,
	"src/images/svgIcon/topping.svg": 37032,
	"src/images/svgIcon/trade.svg": 37325,
	"src/images/svgIcon/trade_rank.svg": 30148,
	"src/images/svgIcon/transferAccount.svg": 51406,
	"src/images/svgIcon/uploadDelete.svg": 81228,
	"src/images/svgIcon/uploadPlus.svg": 97430,
	"src/images/svgIcon/video.svg": 86731,
	"src/images/svgIcon/web3Wallet.svg": 88797,
	"src/images/svgIcon/yieldOrder.svg": 14549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14601;